<template>
  <div>
    <!-- Selector de Fecha de Corte Global -->
    <v-card class="mb-5 pa-4" outlined>
      <h3 class="mb-3">Configuración de Fecha de Corte</h3>
      <v-row align="center">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="fechaCorte"
            label="Fecha de Corte (día 15 por defecto)"
            type="date"
            hint="Define el inicio del ciclo de reporte. Los datos se mostrarán desde esta fecha hasta 30 días después."
            persistent-hint
            @change="actualizarRangoFechaCorte"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-chip color="info" outlined>
            <v-icon left>mdi-calendar-range</v-icon>
            Rango: {{ formatearFechaSoloFecha(fechaInicioCorte) }} - {{ formatearFechaSoloFecha(fechaFinCorte) }}
          </v-chip>
        </v-col>
      </v-row>
    </v-card>

    <!-- Sección de Visitas -->
    <div class="d-flex align-center mb-3">
      <h2 class="flex-grow-1"> Reportes de Visitas</h2>
      <v-btn 
        color="primary" 
        @click="cargarDatosVisitas" 
        :loading="cargandoVisitas"
        :disabled="cargandoVisitas"
      >
        <v-icon left>mdi-eye</v-icon>
        Ver
      </v-btn>
    </div>
    <div v-if="datosVisitasCargados">
      <cartas-personalizadas :cartas="datosVisitas" />
      <div class="row">
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasVisitasHora"
            :valores="valoresVisitasHora"
            :color="'primary'"
            :titulo="'Visitas por hora'"
            :subtitulo="'Visitas registras por hora'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasVisitasSemana"
            :valores="valoresVisitasSemana"
            :color="'primary'"
            :titulo="'Visitas semana (período de corte)'"
            :subtitulo="'Visitas registras en esta semana dentro del período'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasVisitasMes"
            :valores="valoresVisitasMes"
            :color="'primary'"
            :titulo="'Visitas mes (período de corte)'"
            :subtitulo="'Visitas registras por días dentro del período'"
          />
        </div>
      </div>
    </div>
    <v-card v-else class="pa-4 text-center">
      <v-icon large color="primary">mdi-information-outline</v-icon>
      <p class="mt-2">Presiona el botón "Ver" para cargar los datos de visitas</p>
    </v-card>

    <!-- Sección de Pagos -->
    <div class="d-flex align-center mb-3 mt-5">
      <h2 class="flex-grow-1">Reportes de Pagos de membresías</h2>
      <v-btn 
        color="secondary" 
        @click="cargarDatosPagos" 
        :loading="cargandoPagos"
        :disabled="cargandoPagos"
      >
        <v-icon left>mdi-eye</v-icon>
        Ver
      </v-btn>
    </div>
    <div v-if="datosPagosCargados">
      <cartas-personalizadas :cartas="datosPagos" class="mt-3" />
      <div class="row">
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosSemana"
            :valores="valoresPagosSemana"
            :color="'secondary'"
            :titulo="'Pagos semana (período de corte)'"
            :subtitulo="'Pagos registrados esta semana dentro del período'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosMes"
            :valores="valoresPagosMes"
            :color="'secondary'"
            :titulo="'Pagos mes (período de corte)'"
            :subtitulo="'Pagos registrados dentro del período'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosMeses"
            :valores="valoresPagosMeses"
            :color="'secondary'"
            :titulo="'Pagos por meses (período de corte)'"
            :subtitulo="'Pagos registrados por meses dentro del período'"
          />
        </div>
      </div>
    </div>
    <v-card v-else class="pa-4 text-center">
      <v-icon large color="secondary">mdi-information-outline</v-icon>
      <p class="mt-2">Presiona el botón "Ver" para cargar los datos de pagos de membresías</p>
    </v-card>

    <!-- Sección de Pagos de Ventas -->
    <div class="d-flex align-center mb-3 mt-5">
      <h2 class="flex-grow-1">Reportes de Pagos de Ventas</h2>
      <v-btn 
        color="success" 
        @click="cargarDatosVentas" 
        :loading="cargandoVentas"
        :disabled="cargandoVentas"
      >
        <v-icon left>mdi-eye</v-icon>
        Ver
      </v-btn>
    </div>
    <div v-if="datosVentasCargados">
      <cartas-personalizadas :cartas="datosPagosVentas" class="mt-3" />
      <div class="row">
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosVentasSemana"
            :valores="valoresPagosVentasSemana"
            :color="'success'"
            :titulo="'Pagos de Ventas Semana (período de corte)'"
            :subtitulo="'Pagos de ventas registrados esta semana dentro del período'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosVentasMes"
            :valores="valoresPagosVentasMes"
            :color="'success'"
            :titulo="'Pagos de Ventas Mes (período de corte)'"
            :subtitulo="'Pagos de ventas registrados dentro del período'"
          />
        </div>
        <div class="col-sm-6 col-lg-4 col-12">
          <sparkline-component
            :etiquetas="etiquetasPagosVentasMeses"
            :valores="valoresPagosVentasMeses"
            :color="'secondary'"
            :titulo="'Pagos de Ventas por Meses (período de corte)'"
            :subtitulo="'Pagos de ventas registrados por meses dentro del período'"
            :options="{
              responsive: true,
              maintainAspectRatio: false,
              scales: {
                x: {
                  ticks: {
                    font: {
                      size: 12
                    }
                  }
                },
                y: {
                  ticks: {
                    font: {
                      size: 12
                    }
                  }
                }
              }
            }"
          />
        </div>
      </div>
    </div>
    <v-card v-else class="pa-4 text-center">
      <v-icon large color="success">mdi-information-outline</v-icon>
      <p class="mt-2">Presiona el botón "Ver" para cargar los datos de pagos de ventas</p>
    </v-card>

    <v-divider class="my-5"></v-divider>

    <!-- Reporte de Ingresos -->
    <div>
      <div class="d-flex align-center mb-3">
        <h2 class="flex-grow-1">Reporte de Ingresos</h2>
      </div>
      <v-row>
        <v-col cols="12" md="3">
          <v-select
            v-model="filtros.tipo_ingreso"
            :items="tiposIngreso"
            label="Tipo de ingreso"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-select
            v-model="filtros.metodo_pago"
            :items="metodosPago"
            label="Método de pago"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="filtros.fecha_inicio"
            label="Fecha inicio"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            v-model="filtros.fecha_fin"
            label="Fecha fin"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="2">
          <v-btn color="primary" @click="obtenerReporteIngresos" :loading="cargandoReporte" :disabled="cargandoReporte">
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headersReporte"
        :items="reporteIngresos"
        class="elevation-1 mt-3"
        :footer-props="{itemsPerPageText: 'Por página'}"
        :loading="cargandoReporte"
        loading-text="Cargando..."
        no-data-text="No hay ingresos registrados o aún no has realizado una búsqueda."
      >
        <template v-slot:item.fecha="{ item }">
          {{ formatearFechaLocal(item.fecha) }}
        </template>
        <template v-slot:item.monto="{ item }">
          ${{ Number(item.monto).toLocaleString('es-CO') }}
        </template>
        <template v-slot:item.tipo_ingreso="{ item }">
          <span v-if="item.tipo_ingreso === 'membresia'">Membresía</span>
          <span v-else>Producto</span>
        </template>
      </v-data-table>
    </div>

    <v-divider class="my-5"></v-divider>

    <!-- Reporte de Miembros Nuevos -->
    <div>
      <h2>Reporte de Miembros Nuevos</h2>
      <v-row>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="filtrosMiembrosNuevos.fecha_inicio"
            label="Fecha inicio"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="filtrosMiembrosNuevos.fecha_fin"
            label="Fecha fin"
            type="date"
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-btn color="primary" @click="obtenerReporteMiembrosNuevos">
            <v-icon left>mdi-magnify</v-icon>
            Buscar
          </v-btn>
          <v-chip class="ml-2" color="info" v-if="reporteMiembrosNuevos.length === 0 && !cargandoMiembrosNuevos">
            <v-icon left>mdi-information</v-icon>
            Presiona buscar para ver miembros nuevos
          </v-chip>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headersMiembrosNuevos"
        :items="reporteMiembrosNuevos"
        class="elevation-1 mt-3"
        :footer-props="{itemsPerPageText: 'Por página'}"
        :loading="cargandoMiembrosNuevos"
        loading-text="Cargando..."
        no-data-text="No hay miembros nuevos registrados en este período o aún no has realizado una búsqueda."
      >
        <template v-slot:item.fecha_registro="{ item }">
          {{ formatearFechaSoloFecha(item.fecha_registro) }}
        </template>
      </v-data-table>
    </div>

    <v-overlay :value="cargando">
      <v-progress-circular size="64"></v-progress-circular>
    </v-overlay>

    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      top
    >
      {{ mensaje.texto }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import Utiles from "../Servicios/Utiles";
import CartasPersonalizadas from "./Dialogos/CartasPersonalizadas.vue";
import SparklineComponent from "./Dialogos/SparklineComponent.vue";

export default {
  name: "InicioComponent",
  components: { CartasPersonalizadas, SparklineComponent },

  data: () => ({
    cargando: false,
    mostrarMensaje: false,
    mensaje: {
      texto: '',
      color: ''
    },
    // Variables para fecha de corte
    fechaCorte: '',
    fechaInicioCorte: '',
    fechaFinCorte: '',
    // Variables para control de carga bajo demanda
    datosVisitasCargados: false,
    datosPagosCargados: false,
    datosVentasCargados: false,
    cargandoVisitas: false,
    cargandoPagos: false,
    cargandoVentas: false,
    
    // Datos de reportes
    datosVisitas: [],
    datosPagos: [],
    datosPagosVentas: [],
    etiquetasVisitasHora: [],
    valoresVisitasHora: [],
    etiquetasVisitasSemana: [],
    valoresVisitasSemana: [],
    etiquetasVisitasMes: [],
    valoresVisitasMes: [],
    etiquetasPagosSemana: [],
    valoresPagosSemana: [],
    etiquetasPagosMes: [],
    valoresPagosMes: [],
    etiquetasPagosMeses: [],
    valoresPagosMeses: [],
    etiquetasPagosVentasSemana: [],
    valoresPagosVentasSemana: [],
    etiquetasPagosVentasMes: [],
    valoresPagosVentasMes: [],
    etiquetasPagosVentasMeses: [],
    valoresPagosVentasMeses: [],
    filtros: {
      tipo_ingreso: 'todos',
      metodo_pago: 'todos',
      fecha_inicio: '',
      fecha_fin: ''
    },
    tiposIngreso: [
      { text: 'Todos', value: 'todos' },
      { text: 'Membresía', value: 'membresia' },
      { text: 'Producto', value: 'producto' }
    ],
    metodosPago: [
      { text: 'Todos', value: 'todos' },
      { text: 'Efectivo', value: 'efectivo' },
      { text: 'Transferencia', value: 'transferencia' }
    ],
    reporteIngresos: [],
    headersReporte: [
      { text: 'Fecha', value: 'fecha' },
      { text: 'Tipo', value: 'tipo_ingreso' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Monto', value: 'monto' },
      { text: 'Método de pago', value: 'metodo_pago' },
      { text: 'Usuario', value: 'usuario' }
    ],
    cargandoReporte: false,
    // Nuevas variables para el reporte de miembros nuevos
    filtrosMiembrosNuevos: {
      fecha_inicio: '',
      fecha_fin: ''
    },
    reporteMiembrosNuevos: [],
    headersMiembrosNuevos: [
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Fecha de Registro', value: 'fecha_registro' }
    ],
    cargandoMiembrosNuevos: false,
  }),

  mounted() {
    // Inicializar fecha de corte (día 15 del mes actual)
    this.inicializarFechaCorte();
    
    // Inicializar fechas para reportes independientes (no afectados por fecha de corte)
    this.filtros.fecha_inicio = this.obtenerFechaLocal();
    this.filtros.fecha_fin = this.obtenerFechaLocal();
    
    // Inicializar fechas para miembros nuevos
    // Para miembros nuevos, establecemos el primer día del mes actual como fecha de inicio
    const primerDiaMes = new Date();
    primerDiaMes.setDate(1); // Establecer al primer día del mes
    primerDiaMes.setHours(0, 0, 0, 0);
    this.filtrosMiembrosNuevos.fecha_inicio = primerDiaMes.toISOString().slice(0, 10);
    this.filtrosMiembrosNuevos.fecha_fin = this.obtenerFechaLocal();
    
    // Ya no se cargan los datos automáticamente al iniciar
  },

  methods: {
    // Método para obtener la fecha local en formato YYYY-MM-DD
    obtenerFechaLocal() {
      const ahora = new Date();
      // Ajustar a zona horaria de Colombia (UTC-5)
      ahora.setHours(ahora.getHours() - 5);
      return ahora.toISOString().slice(0, 10);
    },

    // Inicializar fecha de corte al día 15 del mes actual
    inicializarFechaCorte() {
      const fechaActual = new Date();
      const año = fechaActual.getFullYear();
      const mes = fechaActual.getMonth(); // 0-indexado
      
      // Siempre usar el día 15 del mes actual como predeterminado
      const fechaCorte15 = new Date(año, mes, 15);
      
      this.fechaCorte = fechaCorte15.toISOString().slice(0, 10);
      this.actualizarRangoFechaCorte();
    },

    // Actualizar el rango de fechas basado en la fecha de corte
    actualizarRangoFechaCorte() {
      if (!this.fechaCorte) return;
      
      const fechaCorteObj = new Date(this.fechaCorte);
      this.fechaInicioCorte = this.fechaCorte;
      
      // La fecha fin es el día 14 del mes siguiente
      const fechaFin = new Date(fechaCorteObj);
      fechaFin.setMonth(fechaFin.getMonth() + 1);
      fechaFin.setDate(14);
      this.fechaFinCorte = fechaFin.toISOString().slice(0, 10);
      
      // Resetear datos cargados para forzar nueva carga con nuevas fechas
      this.datosVisitasCargados = false;
      this.datosPagosCargados = false;
      this.datosVentasCargados = false;
    },

    // Método para formatear fecha manteniendo zona horaria local
    formatearFechaLocal(fecha) {
      if (!fecha) return '';
      
      // Crear fecha sin conversión de zona horaria
      const fechaParts = fecha.split(/[- :]/);
      const fechaLocal = new Date(
        parseInt(fechaParts[0]), // año
        parseInt(fechaParts[1]) - 1, // mes (0-indexado)
        parseInt(fechaParts[2]), // día
        parseInt(fechaParts[3]) || 0, // hora
        parseInt(fechaParts[4]) || 0, // minuto
        parseInt(fechaParts[5]) || 0  // segundo
      );
      
      return fechaLocal.toLocaleString('es-CO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    },
    // Métodos para cargar datos por tipo
    async cargarDatosVisitas() {
      if (this.datosVisitasCargados) return; // Evitar cargar datos ya cargados
      
      this.cargandoVisitas = true;
      try {
        const resultado = await HttpService.obtenerConDatos(
          { 
            metodo: "obtener",
            fecha_inicio_corte: this.fechaInicioCorte,
            fecha_fin_corte: this.fechaFinCorte
          },
          "inicio.php"
        );
        
        // Procesar datos de visitas
        this.datosVisitas = [
          {
            color: "#1e1e1e",
            icono: "mdi-calendar-star",
            nombre: "Total visitas",
            total: resultado.datosVisitas.totalVisitas,
          },
          {
            color: "#1e1e1e",
            icono: "mdi-calendar",
            nombre: "Visitas hoy",
            total: resultado.datosVisitas.visitasHoy,
          },
          {
            color: "#1e1e1e",
            icono: "mdi-calendar-range",
            nombre: "Visitas semana",
            total: resultado.datosVisitas.visitasSemana,
          },
          {
            color: "#1e1e1e",
            icono: "mdi-calendar-month",
            nombre: "Visitas mes",
            total: resultado.datosVisitas.visitasMes,
          },
        ];
        
        this.etiquetasVisitasHora = Utiles.obtenerClaves(resultado.visitasHora);
        this.valoresVisitasHora = Utiles.obtenerValores(resultado.visitasHora);
        
        let visitasSemana = Utiles.cambiarDiaSemana(resultado.visitasSemana);
        this.etiquetasVisitasSemana = Utiles.obtenerClaves(visitasSemana);
        this.valoresVisitasSemana = Utiles.obtenerValores(visitasSemana);
        
        this.etiquetasVisitasMes = Utiles.obtenerClaves(resultado.visitasMes);
        this.valoresVisitasMes = Utiles.obtenerValores(resultado.visitasMes);
        
        this.datosVisitasCargados = true;
        this.onMostrarMensaje({ texto: 'Datos de visitas cargados correctamente', color: 'success' });
      } catch (error) {
        console.error('Error al obtener datos de visitas:', error);
        this.onMostrarMensaje({ texto: 'Error al cargar datos de visitas', color: 'error' });
      } finally {
        this.cargandoVisitas = false;
      }
    },
    
    async cargarDatosPagos() {
      if (this.datosPagosCargados) return; // Evitar cargar datos ya cargados
      
      this.cargandoPagos = true;
      try {
        const resultado = await HttpService.obtenerConDatos(
          { 
            metodo: "obtener",
            fecha_inicio_corte: this.fechaInicioCorte,
            fecha_fin_corte: this.fechaFinCorte
          },
          "inicio.php"
        );
        
        // Procesar datos de pagos
        this.datosPagos = [
          {
            color: "#ffb800",
            icono: "mdi-currency-usd",
            nombre: "Total pagos",
            total: parseFloat(resultado.datosPagos.totalPagos).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }),
          },
          {
            color: "#ffb800",
            icono: "mdi-calendar",
            nombre: "Pagos hoy",
            total: parseFloat(resultado.datosPagos.pagosHoy).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }),
          },
          {
            color: "#ffb800",
            icono: "mdi-calendar-range",
            nombre: "Pagos semana",
            total: parseFloat(resultado.datosPagos.pagosSemana).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }),
          },
          {
            color: "#ffb800",
            icono: "mdi-calendar-month",
            nombre: "Pagos mes",
            total: parseFloat(resultado.datosPagos.pagosMes).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 }),
          },
        ];
        
        let pagosSemana = Utiles.cambiarDiaSemana(resultado.pagosSemana);
        this.etiquetasPagosSemana = Utiles.obtenerClaves(pagosSemana);
        this.valoresPagosSemana = Utiles.obtenerValoresPagos(pagosSemana);
        
        this.etiquetasPagosMes = Utiles.obtenerClaves(resultado.pagosMes);
        this.valoresPagosMes = Utiles.obtenerValoresPagos(resultado.pagosMes);
        
        let pagosMeses = Utiles.cambiarNumeroANombreMes(resultado.pagosMeses);
        this.etiquetasPagosMeses = Utiles.obtenerClaves(pagosMeses);
        this.valoresPagosMeses = Utiles.obtenerValoresPagos(pagosMeses);
        
        this.datosPagosCargados = true;
        this.onMostrarMensaje({ texto: 'Datos de pagos cargados correctamente', color: 'success' });
      } catch (error) {
        console.error('Error al obtener datos de pagos:', error);
        this.onMostrarMensaje({ texto: 'Error al cargar datos de pagos', color: 'error' });
      } finally {
        this.cargandoPagos = false;
      }
    },
    
    async cargarDatosVentas() {
      if (this.datosVentasCargados) return; // Evitar cargar datos ya cargados
      
      this.cargandoVentas = true;
      try {
        const resultado = await HttpService.obtenerConDatos(
          { 
            metodo: "obtener",
            fecha_inicio_corte: this.fechaInicioCorte,
            fecha_fin_corte: this.fechaFinCorte
          },
          "inicio.php"
        );
        
        // Procesar datos de ventas
        this.etiquetasPagosVentasSemana = Utiles.obtenerClaves(resultado.pagosVentasSemana);
        this.valoresPagosVentasSemana = Utiles.obtenerValoresPagos(resultado.pagosVentasSemana);
        
        this.etiquetasPagosVentasMes = Utiles.obtenerClaves(resultado.pagosVentasMes);
        this.valoresPagosVentasMes = Utiles.obtenerValoresPagos(resultado.pagosVentasMes);
        
        this.etiquetasPagosVentasMeses = Utiles.obtenerClaves(resultado.pagosVentasMeses);
        this.valoresPagosVentasMeses = Utiles.obtenerValoresPagos(resultado.pagosVentasMeses);

        // Crear cartas resumen para pagos de ventas
        this.datosPagosVentas = [
          {
            color: "#1e88e5",
            icono: "mdi-currency-usd",
            nombre: "Total ventas",
            total: resultado.pagosVentasMeses.reduce((acc, curr) => acc + parseFloat(curr.total), 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 })
          },
          {
            color: "#1e88e5",
            icono: "mdi-calendar",
            nombre: "Ventas hoy",
            total: (() => {
              if (resultado.pagosVentasMes && resultado.pagosVentasMes.length) {
                const hoy = new Date().getDate();
                const ventaHoy = resultado.pagosVentasMes.find(d => d.dia == hoy);
                return parseFloat(ventaHoy ? ventaHoy.total : 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 });
              }
              return '0';
            })()
          },
          {
            color: "#1e88e5",
            icono: "mdi-calendar-range",
            nombre: "Ventas semana",
            total: this.valoresPagosVentasSemana.reduce((acc, curr) => acc + curr, 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 })
          },
          {
            color: "#1e88e5",
            icono: "mdi-calendar-month",
            nombre: "Ventas mes",
            total: this.valoresPagosVentasMes.reduce((acc, curr) => acc + curr, 0).toLocaleString('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0, maximumFractionDigits: 0 })
          }
        ];
        
        this.datosVentasCargados = true;
        this.onMostrarMensaje({ texto: 'Datos de ventas cargados correctamente', color: 'success' });
      } catch (error) {
        console.error('Error al obtener datos de ventas:', error);
        this.onMostrarMensaje({ texto: 'Error al cargar datos de ventas', color: 'error' });
      } finally {
        this.cargandoVentas = false;
      }
    },

    // El método crearCartas ya no es necesario, su funcionalidad
    // está ahora integrada en los métodos específicos de carga por tipo

    onMostrarMensaje(mensaje) {
      this.mensaje = mensaje
      this.mostrarMensaje = true
    },

    async obtenerReporteIngresos() {
      this.cargandoReporte = true;
      try {
        const res = await fetch(Utiles.generarURL('reporte_ingresos.php'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.filtros)
        });
        const data = await res.json();
        if (data.exito) {
          this.reporteIngresos = data.ingresos;
        } else {
          this.reporteIngresos = [];
        }
      } catch (e) {
        this.reporteIngresos = [];
      } finally {
        this.cargandoReporte = false;
      }
    },

    async obtenerReporteMiembrosNuevos() {
      this.cargandoMiembrosNuevos = true;
      try {
        const res = await fetch(Utiles.generarURL('reporte_miembros_nuevos.php'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(this.filtrosMiembrosNuevos)
        });
        const data = await res.json();
        if (data.exito) {
          this.reporteMiembrosNuevos = data.miembros;
        } else {
          this.reporteMiembrosNuevos = [];
        }
      } catch (e) {
        console.error('Error al obtener miembros nuevos:', e);
        this.reporteMiembrosNuevos = [];
      } finally {
        this.cargandoMiembrosNuevos = false;
      }
    },

    // Método para formatear fecha sin incluir la hora
    formatearFechaSoloFecha(fecha) {
      if (!fecha) return '';
      
      // Crear fecha sin conversión de zona horaria
      const fechaParts = fecha.split(/[- :]/);
      const fechaLocal = new Date(
        parseInt(fechaParts[0]), // año
        parseInt(fechaParts[1]) - 1, // mes (0-indexado)
        parseInt(fechaParts[2]) // día
      );
      
      return fechaLocal.toLocaleDateString('es-CO', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      });
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/InicioComponent.vue